import React, { useRef, lazy } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { useTranslations } from '../i18n/translations';
export function CeoSection() {
  const {
    lang
  } = useLanguage();
  const t = useTranslations(lang);
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="relative py-20 lg:py-28 bg-white overflow-hidden" ref={ref} data-id="element-104">
      <div className="absolute inset-0 pointer-events-none" data-id="element-105">
        <div className="absolute top-20 left-0 w-[400px] h-[400px] rounded-full bg-primary-50/30 blur-3xl hidden sm:block" data-id="element-106" />
        <div className="absolute bottom-0 right-0 w-[300px] h-[300px] rounded-full bg-cyan-50/20 blur-3xl hidden sm:block" data-id="element-107" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="grid lg:grid-cols-5 gap-10 lg:gap-16 items-center" data-id="element-109">
          {/* Photo side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6
        }} className="lg:col-span-2" data-id="element-110">
            <div className="relative max-w-sm mx-auto lg:mx-0" data-id="element-111">
              <div className="aspect-[3/4] rounded-3xl overflow-hidden relative shadow-2xl shadow-navy-900/30" data-id="element-112">
                <img src="https://cdn.magicpatterns.com/uploads/pB9gorEFzofZX96xhoHuNx/telegram-cloud-document-2-5386561911775076958.jpg" alt="Сергій Денисюк — CEO ESCA" className="w-full h-full object-cover object-top" loading="lazy" data-id="element-113" />
              </div>

              <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} animate={isInView ? {
              opacity: 1,
              scale: 1
            } : {}} transition={{
              duration: 0.5,
              delay: 0.4
            }} className="absolute -top-4 -right-4 sm:-top-5 sm:-right-5 bg-white rounded-2xl shadow-xl shadow-navy-200/40 border border-navy-100 p-4 sm:p-5 z-10" data-id="element-114">
                <div className="text-2xl sm:text-3xl font-extrabold bg-gradient-to-r from-primary-600 to-primary-500 bg-clip-text text-transparent" data-id="element-115">
                  20+
                </div>
                <div className="text-xs text-navy-500 font-semibold mt-0.5" data-id="element-116">
                  {'\u0440\u043E\u043A\u0456\u0432 \u043D\u0430 HR \u0440\u0438\u043D\u043A\u0443'}
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* Content side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="lg:col-span-3" data-id="element-117">
            <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-118">
              {t.ceo.eyebrow}
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight" data-id="element-119">
              Сергій Денисюк
            </h2>
            <p className="mt-2 text-lg text-navy-400 font-medium" data-id="element-120">
              {t.ceo.role}
            </p>

            <div className="mt-8 pl-6 border-l-4 border-primary-400/60" data-id="element-121">
              <blockquote className="text-xl sm:text-2xl text-navy-700 leading-relaxed font-medium italic" data-id="element-122">
                {t.ceo.quote}
              </blockquote>
            </div>

            <div className="mt-10 space-y-4" data-id="element-123">
              {t.ceo.points.map((point, index) => <div key={index} className="flex items-start gap-3" data-id="element-124">
                  <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-primary-500 to-primary-600 text-white flex items-center justify-center flex-shrink-0 mt-0.5 shadow-sm" data-id="element-125">
                    <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-126">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-127" />
                    </svg>
                  </div>
                  <p className="text-navy-600 leading-relaxed" data-id="element-128">
                    <strong className="text-navy-900" data-id="element-129">{point.title}</strong>{' '}
                    {point.description}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}